import { jsx } from 'react/jsx-runtime';
import { TabSwitchContent } from './TabSwitch.Content/TabSwitch.Content.es.js';
import { TabSwitchProvider } from './TabSwitch.Context/TabSwitch.Provider.es.js';
import { TabSwitchTab } from './TabSwitch.Tab/TabSwitch.Tab.es.js';
import { TabSwitchTabs } from './TabSwitch.Tabs/TabSwitch.Tabs.es.js';

const TabSwitch = ({ children, ...props })=>{
    return jsx(TabSwitchProvider, {
        ...props,
        children: children
    });
};
TabSwitch.Tab = TabSwitchTab;
TabSwitch.Tabs = TabSwitchTabs;
TabSwitch.Content = TabSwitchContent;
TabSwitch.displayName = 'TabSwitch';

export { TabSwitch, TabSwitch as default };
//# sourceMappingURL=TabSwitch.es.js.map
